import { render, staticRenderFns } from "./LayeredNavigation.vue?vue&type=template&id=10c47a18&"
import script from "./LayeredNavigation.vue?vue&type=script&lang=js&"
export * from "./LayeredNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayeredFilters: require('/~/src/modules/opus-ecom/components/LayeredFilters.vue').default,BreadCrumbs: require('/~/src/modules/opus-ecom/components/BreadCrumbs.vue').default,OpusTitle: require('/~/src/modules/opus/components/Title.vue').default,ReadMore: require('/~/src/modules/opus-ecom/components/ReadMore.vue').default,CategoryTree: require('/~/src/components/CategoryTree.vue').default,OpusButton: require('/~/src/modules/opus/components/Form/Button.vue').default,LayeredSort: require('/~/src/modules/opus-ecom/components/LayeredSort.vue').default,ProductList: require('/~/src/modules/opus-ecom/components/ProductList.vue').default,OpusCard: require('/~/src/modules/opus/components/Card.vue').default,LayeredPagination: require('/~/src/modules/opus-ecom/components/LayeredPagination.vue').default})
